import { ErrorPage } from '@components/ui/ErrorPage'

export function NotFoundPage() {
  return <ErrorPage code="404" />
}
